import React, { useEffect, useState } from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';
import { db } from '../../firebaseConfig';
import { collection, query, where, getDocs, updateDoc, doc } from 'firebase/firestore';

const UnsubscribePromotionalMail = () => {
  const [status, setStatus] = useState('loading'); // loading, success, error
  const [error, setError] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const email = params.get('email');
    if (!email) {
      setStatus('error');
      setError('No email provided.');
      return;
    }
    const unsubscribe = async () => {
      try {
        console.log(email,"emailsdasdad")
        const usersRef = collection(db, 'users');
        const q = query(usersRef, where('email', '==', email));
        const querySnapshot = await getDocs(q);
        if (querySnapshot.empty) {
          setStatus('error');
          setError('No user found with this email.');
          return;
        }
        // Update all matching users (should be one)
        for (const userDoc of querySnapshot.docs) {
          await updateDoc(doc(db, 'users', userDoc.id), {
            isPromotionalMailUnsubscribed: true,
          });
        }
        setStatus('success');
      } catch (err) {
        console.log(err,"errordasdad")
        setStatus('error');
        setError('An error occurred. Please try again later.');
      }
    };
    unsubscribe();
  }, []);

  return (
    <Box sx={{ minHeight: '60vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
      {status === 'loading' && <CircularProgress />}
      {status === 'success' && (
        <Typography variant="h5" color="primary" align="center">
          You are now unsubscribed from promotional emails.
        </Typography>
      )}
      {status === 'error' && (
        <Typography variant="h6" color="error" align="center">
          {error}
        </Typography>
      )}
    </Box>
  );
};

export default UnsubscribePromotionalMail; 